import type { FC } from "react";

import { motion } from "framer-motion";

interface InstanceStatCellProps {
  label: string;
  value: string;
  sub?: string;
  accentColor: string;
  fillPct?: number;
  /** Idle/empty state: value renders dim slate instead of the accent —
   *  calm, not broken. */
  dim?: boolean;
}

export const InstanceStatCell: FC<InstanceStatCellProps> = ({
  label,
  value,
  sub,
  accentColor,
  fillPct,
  dim = false,
}) => (
  <div
    className="relative border bg-white/60 px-1.5 py-1 sm:px-2 sm:py-1.5 dark:bg-slate-900/60"
    style={{ borderColor: `${accentColor}33` }}
  >
    {fillPct !== undefined && (
      <motion.div
        className="absolute inset-y-0 left-0"
        initial={{ width: 0 }}
        animate={{ width: `${fillPct}%` }}
        transition={{ duration: 0.5, ease: "easeOut" }}
        style={{ backgroundColor: `${accentColor}18` }}
      />
    )}
    <p className="relative font-mono text-[8px] font-bold uppercase tracking-[0.18em] text-slate-500 sm:text-[9px] sm:tracking-[0.2em]">
      {label}
    </p>
    <div className="relative mt-0.5 flex items-baseline gap-1">
      <span
        className={`font-mono font-semibold tabular-nums ${
          dim ? "text-[10px] sm:text-xs" : "text-xs sm:text-sm"
        }`}
        style={{ color: dim ? undefined : accentColor }}
      >
        <span
          className={dim ? "text-slate-400 dark:text-slate-600" : undefined}
        >
          {value}
        </span>
      </span>
      {sub && (
        <span className="font-mono text-[8px] tracking-tight text-slate-500 sm:text-[9px]">
          {sub}
        </span>
      )}
    </div>
  </div>
);
